import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { OrderItem } from "src/contexts/documentationArea/domain/OrderItem";
import { ExtractionState } from "src/contexts/documentationArea/domain/ExtractionState";
import { colors } from "@permisso/permisso-components";

interface OrderBoxHeaderIconProps {
  order: OrderItem;
}

export const OrderBoxHeaderIcon = ({ order }: OrderBoxHeaderIconProps) => {
  const { defaultGreen, defaultRed, defaultYellow, grey700 } = colors;
  const state = order.getExtractionState();

  switch (state) {
    case ExtractionState.COMPLETED:
      return (
        <Icon color={defaultGreen} path={ICON_PATHS.CHECK_CIRCLE_THIN} size={ICON_SIZES.s20} />
      );
    case ExtractionState.PENDING:
      return (
        <Icon
          color={defaultYellow}
          path={ICON_PATHS.EXCLAMATION_CIRCLE_THIN}
          size={ICON_SIZES.s20}
        />
      );
    case ExtractionState.PENDING_REVIEW:
      return <Icon color={grey700} path={ICON_PATHS.CLOCK} size={ICON_SIZES.s20} />;
    case ExtractionState.FAILED:
    case ExtractionState.INVALID:
      return <Icon color={defaultRed} path={ICON_PATHS.CROSS_CIRCLE_THIN} size={ICON_SIZES.s20} />;
    case ExtractionState.IDLE:
    case ExtractionState.PROCESSING:
    case ExtractionState.CANCELLED:
      return null;
    default:
      return null;
  }
};
